export const SUBMIT_STATUSES = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
} as const;

export type SubmitStatus = (typeof SUBMIT_STATUSES)[keyof typeof SUBMIT_STATUSES];

export const LOCKED_STATUSES: readonly SubmitStatus[] = [
  SUBMIT_STATUSES.SUBMITTED,
  SUBMIT_STATUSES.APPROVED,
] as const;
